import React from 'react';
import bhs from './../../image/education/bhs.jpg'
import bhsLogo from './../../image/education/bhs_logo.jpg'
import cam from './../../image/education/cambrian.jpg'
import camLogo from './../../image/education/cam_logo.png'
import iub from './../../image/education/iub.jpg'
import iubLogo from './../../image/education/iub_logo.png'
const Education = () => {
    return (
        <div className=" edu_part">

            <div className="heading">

                <hr />
                <h3 id="education">Education</h3>
            </div>
            <div className="edu ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="ins">
                                <div className="ins_logo"><img src={bhsLogo} alt="" /></div>
                                <div className="ins_bg_img"><img src={bhs} alt="" /></div>
                                <div className="ins_content">
                                    <h4>Bhasantek School &amp;College</h4>
                                    <p>2003 - 2014</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="ins">
                                <div className="ins_logo"><img src={camLogo} alt="" /></div>
                                <div className="ins_bg_img"><img src={cam} alt="" /></div>
                                <div className="ins_content">
                                    <h4>Cambrian School &amp; College</h4>
                                    <p>2014 - 2016</p>
                                </div>
                            </div>

                        </div>
                        <div className="ins col-lg-4 col-md-6">
                            <div className="ins">
                                <div className="ins_logo"><img src={iubLogo} alt="" /></div>
                                <div className="ins_bg_img"><img src={iub} alt="" /></div>
                                <div className="ins_content ">
                                    <h4>Independent University, Bangladesh</h4>
                                    <p>2017 - 2021</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Education;